export default __webpack_public_path__ + "static/media/arrow_forward_black_24dp.e7821fd3.svg";